import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import { setProjectDetailsIsEdit } from "./redux/actions";
import ProjectsRegisterTable from "./projectsRegisterTable";
import { PlusOutlined } from "@ant-design/icons";
import { fetchProjectStatuses } from "../ProjectStatuses/redux/actions";
import ExportProjects from "./exportProjects";
import Tooltip from "../../components/tooltip-Custom";

const ProjectSetup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.project_setup?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  useEffect(() => {
    dispatch(fetchProjectStatuses());
  }, []);

  return (
    <div className="page-top-div">
      <span className="text-span">Project Setup</span>
      <Row className="production-manager-parent-row card-container">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]} justify="space-between">
            <Col>
              <Row align="middle" gutter={[80, 0]}>
                <Col>
                  <div>
                    <span className="heading-span">Projects Register</span>
                  </div>
                </Col>
                <Col>
                  {canUpdate && (
                    <Button
                      onClick={() => {
                        navigate("/projects-setup/create-project");
                        dispatch(setProjectDetailsIsEdit(true));
                      }}
                      icon={<PlusOutlined />}
                      className="add-user-btn"
                      size="middle"
                      style={{
                        width: "105%",
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                    >
                      PROJECT
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
            <Col>
              {user?.permissions?.project_setup?.export && (
                <Tooltip text="Export">
                  <ExportProjects />
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <ProjectsRegisterTable
            canUpdate={canUpdate}
            canDelete={user?.permissions?.project_setup?.delete || false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProjectSetup;
